import React from "react";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import {formatRoute} from 'react-router-named-routes';

import AuthLayout from "../../shared/containers/AuthLayout";
import {getSeniors} from "../members/actions/seniorsAction";
import * as messageAction from "./actions/messageAction";
import {MESSAGE_FINISH_ALL} from "./constants/actionTypes";
import {MESSAGE_TYPE_SEND} from "./constants";
import {
  RC_STATUS_OFFLINE,
  RC_USER_PREFIX_T
} from "../../shared/modules/rocketChat/constants";
import {TW_VIDEO_TAG} from "../../shared/modules/twilio/constants";
import {hash} from "../../shared/actions";
import TextMessage from "./components/textMessage";
import ImageMessage from "./components/imageMessage";
import {ROUTER_MESSAGE_SENIOR_IMAGE} from "../../shared/constants/routers";
import { ANALYTICS_SPECS } from "../../shared/constants";
import { sendAnalyticsEvent } from "../../shared/actions/analytics";
import { setHistoryRead } from "../../shared/modules/rocketChat/actions/rocketChatAction";

export class MessageContainer extends React.Component {

  static propTypes = {
    seniors: PropTypes.array,
    user: PropTypes.object,
    message: PropTypes.object,
    rocketChat: PropTypes.object.isRequired,
    onHandleMessage: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired
  };

  static defaultProps = {
    seniors: [],
    user: {},
    message: {}
  };

  constructor(props) {
    super(props);
    this.msgRef = React.createRef();
    this.state = { senior: {} };
  }

  renderMessage = (item, messageIndex) => {
    const message = messageAction.processMessage(item.text);
    const components = {text: TextMessage, image: ImageMessage};
    const MessageComponent = components[message.media];

    return (
      <div
        className={`message${item.type === MESSAGE_TYPE_SEND ? 'Sent' : 'Received'}`}
        key={messageIndex}
      >
        <MessageComponent item={item} message={message}/>
      </div>
    );
  };

  componentWillUnmount() {
    this.props.dispatch(setHistoryRead(this.props.message.user));
    this.props.dispatch({type: MESSAGE_FINISH_ALL});
    document.removeEventListener('scroll', this.showScrollButton);
  }

  async componentDidMount() {
    const {match} = this.props;
    const seniors = await this.props.dispatch(getSeniors());
    const senior = messageAction.getSeniorByHash(seniors, match.params.seniorHash);

    this.props.dispatch(messageAction.start(RC_USER_PREFIX_T + senior.prof_id));
    this.setState({senior});
  }

  render() {
    const {senior} = this.state;
    const {message, rocketChat} = this.props;

    const userId = `${RC_USER_PREFIX_T}${senior.prof_id}`;
    const roomId = rocketChat.rooms[userId] && rocketChat.rooms[userId].rid;

    if (!senior.firstname) return null;

    const messages = (message.items[roomId] || [])
      .filter((item) => {
        return !item.text.startsWith(TW_VIDEO_TAG);
      })
      .slice(0)
      .reverse()
      .map(this.renderMessage);

    return (
      <AuthLayout
        onBackLink={this.props.history.goBack}
        headerClass="shortHeader"
        isBackLink
        title={`${senior.firstname} ${senior.lastname}`}
      >
        <div className="messageStream">
          <div name="messagesEnd" ref={(el) => {
            this.messagesEnd = el;
          }}/>
          {messages}
        </div>,
        <div className="messageEditor">
          <div>{message.isTyping ? __("%firstname% currently writing").replace('%firstname%', senior.firstname) : ''}</div>
          <div className="messageFieldContainer">
            <textarea className="navbarDisplay"
                      ref={this.msgRef}
                      id="textArea"
                      onChange={this.props.onHandleMessage}
            />
            {!this.props.message.isOnline &&
            <span>{__("Waiting for connection")}</span>}

            <div className="messageActions">
              <Link className="picture"
                    onClick={() => sendAnalyticsEvent(ANALYTICS_SPECS.MESSAGING.NAME, ANALYTICS_SPECS.MESSAGING.EVENTS.TAP_PICTURE_ICON) }
                    to={formatRoute(ROUTER_MESSAGE_SENIOR_IMAGE, {seniorHash: hash(senior.prof_id)})}>
                <i className="fa fa-camera" />
              </Link>
              <div className="send" onClick={() => {
                this.msgRef.current.value="";
                this.props.onSend();
              }}>
                <i className="fa fa-telegram"/>
              </div>
            </div>

          </div>
        </div>
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    seniors: state.seniors,
    user: state.user,
    message: state.message,
    rocketChat: state.rocketChat
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    onHandleMessage: (event) => dispatch(messageAction.typing(event.target.value)),
    onStartClick: (user) => dispatch(messageAction.start(RC_USER_PREFIX_T + user)),
    onSend: () => dispatch(messageAction.send())
  };
};

const mergeState = (state, dispatch, own) => {
  return {
    ...own,
    ...state,
    ...dispatch,
    onLeft: (user) => {
      const username = RC_USER_PREFIX_T + user;
      const userStatus = (Object
          .values(state.rocketChat.users)
          .find((rocketChatUser) => rocketChatUser.username === username) || {}
      ).status || RC_STATUS_OFFLINE;

      return (
        <div className={userStatus}>
        </div>
      );
    },
    onRight: (user) => {
      const username = RC_USER_PREFIX_T + user;

      return (
        <div>
          {username in state.message.missed && state.message.missed[username] > 0
            ? <span
              className="missedContactCount">{state.message.missed[username]}</span>
            : ''}
          <i className="fa fa-envelope"/>
        </div>
      );
    }
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeState)(MessageContainer));
